import React from 'react'
import './Reviews.css';
export default function Reviews() {
  return (
   <>
   
   
   
   
   
   <section class="testimonials-section">
        <h2>What Our Clients Say About Palm Leaf Nadi Astrology</h2>
        <div class="testimonials-container">
    <div class="testimonial-card">
        <div class="testimonial-name">Sophia</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"The insights I received through Nadi Astrology were incredible! The predictions helped me understand my future path and make informed decisions."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Liam</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"The reading was very accurate and provided clarity about my career. It gave me the confidence to pursue new opportunities. Highly recommended!"</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Amina</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"I was amazed by the precision of the reading. It was spot-on, and the remedies have already started to bring positive changes in my life."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Hassan</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"The experience was enlightening. I received valuable guidance, but there could have been more follow-up on the remedies suggested."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Carlos</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"The predictions were spot-on, and the entire process was smooth and professional. I feel much more at peace with my future."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Priya</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"Such an insightful experience! I’ve had several astrology readings before, but this one was by far the most accurate. I’m so grateful for the guidance."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Giovanni</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"The reading was helpful, and I appreciated the deep analysis. I look forward to seeing how the guidance unfolds in my life."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Maya</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"A truly remarkable experience! The astrologer was very detailed, and the advice I received was practical and actionable. I highly recommend this service."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Omar</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"The reading was very good, but I would have loved more specific details. Still, I feel more aligned with my life path now."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Sofia</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"I’m so happy I decided to try Nadi Astrology. The predictions were so accurate, and I’ve already started to feel the positive effects."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Tariq</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"The astrologer was incredibly knowledgeable and provided me with invaluable insights. I feel like I’m on the right track now."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Helena</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"A very accurate and thought-provoking reading. I’m eager to see how the guidance helps me in the long term."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Rajeev</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"The accuracy of the predictions was amazing. I now have a clear understanding of my career and relationship paths, and I feel empowered."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Eva</div>
        <div class="testimonial-stars">★★★★☆</div>
        <p class="testimonial-review">"An enlightening experience. I was impressed by the depth of the reading, and the remedies suggested were practical and easy to follow."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Santiago</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"Incredible insights! The reading was so accurate, and I felt a deep connection to the astrologer’s wisdom. I highly recommend the service."</p>
    </div>
    <div class="testimonial-card">
        <div class="testimonial-name">Nina</div>
        <div class="testimonial-stars">★★★★★</div>
        <p class="testimonial-review">"The Palm Leaf Nadi Astrology reading was amazing! It revealed truths about my life that I had never considered before. I feel much more in control now."</p>
    </div>
</div>

    </section>
   
   
   </>
  )
}
